"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createStarredDocumentUid = createStarredDocumentUid;
exports.createStarredDocumentData = createStarredDocumentData;
function createStarredDocumentUid(documentUid, userUid) {
    return `${documentUid}:${userUid}`;
}
function createStarredDocumentData(documentUid, userUid) {
    return {
        uid: createStarredDocumentUid(documentUid, userUid),
        created_at: new Date().getTime(),
        updated_at: new Date().getTime(),
        document_uid: documentUid,
        owner_uid: userUid,
    };
}
//# sourceMappingURL=starred.js.map